// extracted by mini-css-extract-plugin
export var card = "_qo-0";
export var content = "_qo-2";
export var details = "_qo-3";
export var icon = "_qo-1";
export var iconBlue = "_qo-5";
export var iconBrand = "_qo-4";
export var iconGrayBlue = "_qo-6";
export var iconGreen = "_qo-7";
export var iconIndigo = "_qo-8";
export var iconOrange = "_qo-9";
export var iconPurple = "_qo-a";
export var iconRed = "_qo-b";
export var iconWarning = "_qo-c";